import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetOperationHistory,
  PostOperationHistory,
  Status,
} from '../../services/apiTypes';
import {
  HistorySearchParam,
  getHistory as getHistoryAPI,
  postHistory as postHistoryAPI,
} from './api';
import { isGetOperationHistoryList } from '../../_utils/typeGuardUtils';

interface historyState {
  status: Status;
  historyData: GetOperationHistory;
}

const initialState: historyState = {
  status: 'idle',
  historyData: {
    totalRows: 0,
    operationHistoryList: [],
  },
};

export const getHistory = createAsyncThunk(
  'history/getOperationHistory',
  async (params: HistorySearchParam, { rejectWithValue }) => {
    try {
      return await getHistoryAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const postHistory = createAsyncThunk(
  'history/postOperationHistory',
  async (params: PostOperationHistory, { rejectWithValue }) => {
    try {
      return await postHistoryAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const historySlice = createSlice({
  name: 'historyData',
  initialState,
  reducers: {
    resetHistoryData: (state) => {
      state.historyData = initialState.historyData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHistory.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getHistory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetOperationHistoryList(action.payload)) {
          state.historyData = action.payload;
        }
      })
      .addCase(getHistory.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(postHistory.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postHistory.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(postHistory.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { resetHistoryData } = historySlice.actions;

export default historySlice.reducer;
